import {
	BRAND_SETTINGS_ROUTE_ID,
	BRAND_ALTERNATE_PAYMENT_ROUTE_ID,
	BRAND_DARES_ROUTE_ID,
	CAMPAIGNS_PAGE_ROUTE_ID,
	LOGIN_ROUTE_ID,
	AGENCY_PUBLISHERS_LIST_ROUTE_ID,
	AGENCY_ACCOUNT_MANAGERS_LIST_ROUTE_ID,
	PUBLISHER_NOTIFICATION_SETTINGS_ROUTE_ID,
	WHITELISTED_CREATORS_ROUTE_ID,
	CAMPAIGNS_DASHBOARD_ROUTE_ID,
	CAMPAIGN_CREATORS_ROUTE_ID,
	CAMPAIGN_CLIPS_ROUTE_ID,
	CAMPAIGN_DARES_ROUTE_ID,
	CREATOR_CAMPAIGN_DARES_ROUTE_ID,
	CAMPAIGN_DASHBOARD_ROUTE_ID,
	CAMPAIGNS_CREATORS_ROUTE_ID,
	CAMPAIGNS_CLIPS_ROUTE_ID, PUBLISHER_BAN_LIST_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth'
import {
	BRAND_SETTINGS_FORM_MODULE_ID,
	BRAND_ALTERNATE_PAYMENT_FORM_MODULE_ID,
	HELPER_WIDGET_MODULE_ID,
	AGENCY_PUBLISHERS_LIST_MODULE_ID,
	ADD_AGENCY_PUBLISHER_FORM_MODULE_ID,
	PUBLISHER_NOTIFICATION_SETTINGS_MODULE_ID,
	CAMPAIGN_DARES_LIST_MODULE,
	CREATOR_CAMPAIGN_DARES_LIST_MODULE,
} from 'root/src/shared/descriptions/modules/moduleIds'
import currentRouteObj from 'root/src/client/logic/route/selectors/currentRouteObj'
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants'

const getDropEventPayload = {
	endpointId: dropEndpointIds.DROP_GET_EVENT,
	payload: (state) => {
		const {
			routeParams: { recordId },
		} = currentRouteObj(state)
		return { recordId }
	},
}

export default {
	[CAMPAIGNS_PAGE_ROUTE_ID]: {
		// Served by the redesign page (RedesignCampaignsPage) in place at this URL. No legacy modules:
		// the global <RenderModules /> would otherwise render the OLD design below the redesign content
		// and refetch the same list on enter. The redesign page loads its own data over tRPC.
		url: '/campaigns',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		chatWidget: true,
		discordWidget: true,
		modules: [],
	},
	[BRAND_SETTINGS_ROUTE_ID]: {
		url: '/publisher-settings',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		chatWidget: true,
		discordWidget: true,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [
			HELPER_WIDGET_MODULE_ID,
			BRAND_SETTINGS_FORM_MODULE_ID,
		],
	},
	[BRAND_ALTERNATE_PAYMENT_ROUTE_ID]: {
		url: '/brand-payment',
		noSitemap: true,
		modules: [
			HELPER_WIDGET_MODULE_ID,
			BRAND_ALTERNATE_PAYMENT_FORM_MODULE_ID,
		],
	},
	[BRAND_DARES_ROUTE_ID]: {
		// Served by the redesign page (RedesignPublisherDaresPage) in place at this URL. No legacy modules:
		// the global <RenderModules /> would otherwise render the OLD design below the redesign content
		// and refetch the same list on enter. `mainModule` went with them: it only pointed the legacy
		// pagination/navigation helpers at the list module that no longer renders here.
		url: '/publisher-dares',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		modules: [],
	},
	[AGENCY_PUBLISHERS_LIST_ROUTE_ID]: {
		url: '/publishers-list',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.agencyAccountManager,
		variantModules: [
			{ label: 'Publishers', modules: [AGENCY_PUBLISHERS_LIST_MODULE_ID] },
			{
				label: 'Add publisher',
				modules: [
					ADD_AGENCY_PUBLISHER_FORM_MODULE_ID,
				],
			},
		],
	},
	[AGENCY_ACCOUNT_MANAGERS_LIST_ROUTE_ID]: {
		// Served by the redesign page (RedesignAccountManagersPage) in place at this URL. No legacy
		// modules: the global <RenderModules /> would otherwise render the OLD design below the redesign
		// content and refetch the same list on enter. The legacy `variantModules` tab switcher
		// (Account managers / Add account manager) went with them, since the redesign page owns its own
		// list and its invite-by-email dialog.
		url: '/account-managers',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.agency,
		modules: [],
	},
	[PUBLISHER_NOTIFICATION_SETTINGS_ROUTE_ID]: {
		url: '/publisher-notification-settings',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		chatWidget: true,
		discordWidget: true,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [
			PUBLISHER_NOTIFICATION_SETTINGS_MODULE_ID,
		],
	},
	[WHITELISTED_CREATORS_ROUTE_ID]: {
		// Served by the redesign page (RedesignWhitelistedCreatorsPage) in place at this URL. No legacy
		// modules: the global <RenderModules /> would otherwise render the OLD design below the redesign
		// content and refetch the same list on enter. The redesign page loads its own data over tRPC.
		url: '/whitelisted-creators',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		chatWidget: true,
		discordWidget: true,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [],
	},
	[CAMPAIGN_DASHBOARD_ROUTE_ID]: {
		// Served by the redesign page (RedesignCampaignDashboardPage) in place at this URL. No legacy
		// modules: the global <RenderModules /> would otherwise render the OLD dashboard below the redesign
		// content. `serverSideRequests` stays: it fills the drop record the shared campaign chrome reads.
		url: '/campaign-dashboard/:recordId',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		serverSideRequests: [
			getDropEventPayload,
		],
		modules: [],
	},
	[CAMPAIGNS_DASHBOARD_ROUTE_ID]: {
		// Served by the redesign page (RedesignCampaignDashboardPage) in place at this URL. No legacy
		// modules: the global <RenderModules /> would otherwise render the OLD dashboard below it.
		url: '/campaign-dashboard',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [],
	},
	[CAMPAIGN_CREATORS_ROUTE_ID]: {
		url: '/campaign-creators/:recordId',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		serverSideRequests: [
			getDropEventPayload,
		],
		modules: [],
	},
	[CAMPAIGNS_CREATORS_ROUTE_ID]: {
		url: '/campaign-creators',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [],
	},
	[CAMPAIGN_CLIPS_ROUTE_ID]: {
		url: '/campaign-clips/:recordId',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		serverSideRequests: [
			getDropEventPayload,
		],
		// Served by the redesign page (RedesignCampaignClipsPage) in place at this URL, so no legacy
		// modules: the global <RenderModules /> would otherwise render the OLD clips list below it.
		modules: [],
	},
	[CAMPAIGNS_CLIPS_ROUTE_ID]: {
		// Served by the redesign page (RedesignCampaignClipsPage) in place at this URL. No legacy modules:
		// the global <RenderModules /> would otherwise render the OLD clips list below the redesign content.
		url: '/campaign-clips',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [],
	},
	[CAMPAIGN_DARES_ROUTE_ID]: {
		url: '/campaign-dares/:recordId',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [CAMPAIGN_DARES_LIST_MODULE],
	},
	[CREATOR_CAMPAIGN_DARES_ROUTE_ID]: {
		url: '/creator-dares/:recordId',
		makeRequestsOnClient: true,
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brandUser,
		defaultRouteId: LOGIN_ROUTE_ID,
		modules: [CREATOR_CAMPAIGN_DARES_LIST_MODULE],
	},
	[PUBLISHER_BAN_LIST_ROUTE_ID]: {
		// Served by the redesign page (RedesignBannedCreatorsPage) in place at this URL. No legacy modules:
		// the global <RenderModules /> would otherwise render the OLD design below the redesign content
		// and refetch the same list on enter. The redesign page loads its own data over tRPC.
		url: '/publisher-banned-creators',
		noSitemap: true,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.brand,
		chatWidget: true,
		discordWidget: true,
		modules: [],
	},
}
